import React from 'react'
import './TeamcenterCommunityCollaboration.css'
import TeamCenterCommunityCollaborationOverview from './TeamCenterCommunityCollaborationOverview'
import BannerImage from '../../../assets/other_image/sharePoint.jpg'
import Letsgetintouch from '../BusinessProcessAndChangeManagement/Letsgetintouch'
import Banner from '../Banner/Banner'
import FloatingContactUs from '../../floting_contact/FloatingContactUs'

const TeamcenterCommunityCollaboration = () => {
  return (
    <section className="TeamcenterCommunity-management">
    
    <Banner
        image={BannerImage} // Pass the image for this page
        heading=" Teamcenter Community Collaboration " // Pass the heading text for this page
      />

      <div>
         <FloatingContactUs />
      </div>

      <TeamCenterCommunityCollaborationOverview/>
      <section style={{ background: "#f5f7fa" }}>
      <div className="benefits container">
      <h4 className="TeamcenterCommunity-page-heading">Unlock the Power :</h4>
      <h5 className="TeamcenterCommunity-subheading">
        Discover the Transformative Benefits of Teamcenter Community Collaboration with NexTech!
      </h5>
      <ul className="custom-bullets">
        <li>Offers a reliable, secure and compliant platform for sharing information.  </li>
        <li>Providing real-time collaboration, application sharing and social computing so teams can work together the when where and how they want. </li>
      </ul>
    </div>
    </section>

    <section>

    <div className="solutions container">
      <h4 className="TeamcenterCommunity-page-heading">Teamcenter Solutions</h4>
     <p className='plmimplementationparagraph'>
     MOS Installation and configuration in existing domain, new domain, separate forest with server farm, load balancing, configuring LAN, DNS for WINS, install community collaboration and conferencing server, troubleshooting, integration with Teamcenter product suite, collaboration script configuration and installation, SSL enablement, backup & restore. 
     </p>
    </div>

    <div className='best-practices container'>
      <h4 className="TeamcenterCommunity-page-heading">Best Practices</h4>
     <p className='plmimplementationparagraph'>
     We help customer to use best practices for Teamcenter data access inside SharePoint, performing workflow action, visual conferencing, JT integration, using clipboard, assembly upload/download, thumbnail generation, visual issue management, rollup web part and many more. 
     </p>
    </div>
    </section>

    <section style={{ background: "#f5f7fa" }}>
    <div className="why-nextech container">
      <h4 className="TeamcenterCommunity-page-heading">Why NexTech?</h4>
      <h5 className="TeamcenterCommunity-subheading">For Teamcenter Community Collaboration</h5>
      <ul className="custom-bullets">
        <li>
        Expertise in MOS Installation: We excel in MOS installation and configuration across various domains and server environments, ensuring seamless integration and optimal performance.  
        </li>
        <li>
        Comprehensive Support Services: Our offerings include troubleshooting, integration with the Teamcenter suite, collaboration script configuration, SSL enablement, and backup & restore, ensuring a robust and reliable platform.  
        </li>
        <li>
        Real-Time Collaboration Capabilities: NexTech facilitates real-time collaboration, application sharing, and social computing within Teamcenter, enabling flexible teamwork anytime, anywhere.  
        </li>
        <li>
        Implementation of Best Practices: We assist in implementing best practices for Teamcenter data access, workflow actions, visual conferencing, JT integration, and issue management, enhancing efficiency and usability.   
        </li>
        <li>
        Reliable, Secure, and Compliant Platform: NexTech provides a reliable, secure, and compliant platform for sharing information, ensuring data integrity and regulatory adherence.   
        </li>
      </ul>
    </div>
    </section>
<Letsgetintouch/>
  </section>
  )
}

export default TeamcenterCommunityCollaboration